/** *****************************
 * Globals, globals, globals
 */
global.$body = $("body");
global.$window = $(global.window);
global.isDevice = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) !== null;
global.isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|Opera Mini|IEMobile/i) !== null;

let _ = require("underscore"),
    Backbone = require("backbone");

let App = function ZimmoApp () {

};
_.extend(App.prototype, Backbone.Events);
_.extend(App.prototype, {
    locale: "nl",

    start: function (options) {
        this.trigger("start", options);
    }
});

module.exports = new App();
global.app = module.exports;
